<div class="survey" *ngIf="isLogin && surveyList?.length">
  <div class="survey__menu">
    <div class="progress-container">
      <div class="progress-bar" [style.width.%]="progress"></div>
    </div>

    <div class="survey__menu--body">

      @if(showThanksScreen){
      <h3>Thank you for completing the survey!</h3>
      <section class="mt-2">
        <p style="font-size: 0.9rem;color: #8d858c;">Follow tags have been added to your preferences. U can go to
          settings to remove them if u like</p>
        <div class="flex mt-5">

          <span class="tag" *ngFor="let i of commonService.userTagList">{{i}}</span>
        </div>


      </section>
      }
      @else{

      <ng-container>
        @if(showSurveySelection){
        <div class="survey-list">
          @for(item of surveyList; track item){
          <div (click)="selectSurvey(item)">
            <svg viewBox="0 0 32 44" fill="none">
              <path
                d="M28 4H18C18 5.1 17.1 6 16 6C14.9 6 14 5.1 14 4H4C1.8 4 0 5.8 0 8V40C0 42.2 1.8 44 4 44H28C30.2 44 32 42.2 32 40V8C32 5.8 30.2 4 28 4Z"
                fill="#455A64" />
              <path d="M28 41H4C3.4 41 3 40.6 3 40V8C3 7.4 3.4 7 4 7H28C28.6 7 29 7.4 29 8V40C29 40.6 28.6 41 28 41Z"
                fill="white" />
              <path d="M18 4C18 5.1 17.1 6 16 6C14.9 6 14 5.1 14 4H7V8C7 9.1 7.9 10 9 10H23C24.1 10 25 9.1 25 8V4H18Z"
                fill="#90A4AE" />
              <path
                d="M16 0C13.8 0 12 1.8 12 4C12 6.2 13.8 8 16 8C18.2 8 20 6.2 20 4C20 1.8 18.2 0 16 0ZM16 6C14.9 6 14 5.1 14 4C14 2.9 14.9 2 16 2C17.1 2 18 2.9 18 4C18 5.1 17.1 6 16 6Z"
                fill="#90A4AE" />
              <path d="M13 20H25V22H13V20ZM7 19H11V23H7V19Z" fill="#CFD8DC" />
              <path d="M13 29H25V31H13V29ZM7 28H11V32H7V28Z" fill="#03A9F4" />
            </svg>

            <span> {{ item.title }}</span>
          </div>

          }
        </div>

        }@else{ @if(questions[currentStep]?.question_type == "multiple"){
        <div class="question">{{ questions[currentStep]?.question_text }}?</div>
        <!-- <div class="answer-required">Answer required</div> -->
        <div class="answer">
          <form [formGroup]="checkboxForm" class="grid-3">
            <label [for]="'mu' + i" class="choice-button my-checkbox"
              *ngFor="let checkbox of questions[currentStep].options; let i = index">
              <div class="icon">
                <i class="fa-solid fa-{{ icons[checkbox.value] }}"></i>
              </div>
              <div class="check">
                <input type="checkbox" [id]="'mu' + i" (change)="checkbox.checked = !checkbox.checked" />
                <span>{{ checkbox.value }}</span>
              </div>
            </label>
          </form>
        </div>
        } @else if (questions[currentStep]?.question_type == "single") {

        @if(questions[currentStep]?.question_text == "seller_form"){

        <div class="container">

          <form [formGroup]="joinUsForm">
            <div class="join-title mt-3">Join Us as a</div>

            <div class="checkbox-group d-flex">
              <div>
                <input type="radio" id="homeBiz" value="Home Biz" formControlName="sellerType">
                <label for="homeBiz" class="ml-1">Home Biz</label>
              </div>
              <div class="ml-2">
                <input type="radio" value="Business" id="business" formControlName="sellerType">
                <label for="business" class="ml-1">Business</label>
              </div>
            </div>

            <input type="text" class="form-control" placeholder="Category" formControlName="category">
            <textarea class="form-control textarea mt-2" placeholder="Description"
              formControlName="description"></textarea>
          </form>
        </div>

        }@else{
        <div class="question">{{ questions[currentStep]?.question_text }}?</div>
        <!-- <div class="answer-required">Answer required</div> -->
        <div class="answer">
          <div class="my-checkbox mb-1" *ngFor="let radio of questions[currentStep].options; let i = index"
            (click)="questions[currentStep].value = radio">
            <input type="radio" [id]="'si' + i" name="age" [value]="radio" [(ngModel)]="questions[currentStep].value"
              (click)="$event.stopPropagation()" />
            <label [for]="'si' + i" class="ml-2"> {{ radio }}</label>
          </div>
        </div>
        }




        } @else if(questions[currentStep]?.question_type == "text") {
        <div class="question"> {{ questions[currentStep]?.question_text }}?</div>
        <!-- <div class="answer-required">Answer required</div> -->
        <div class="answer">
          <textarea class="form-control" [(ngModel)]="questions[currentStep].text"></textarea>
        </div>
        } }
      </ng-container>
      }


    </div>

    <div class="button-container" *ngIf="!showThanksScreen">
      @if(currentStep > 0 ) {
      <button (click)="previousStep()" [disabled]="currentStep === 0"><i class="fas fa-chevron-left"></i>
        Previous</button>
      } @else {
      <div></div>
      } @if(currentStep < totalSteps){ <button (click)="nextStep()" [disabled]="currentStep === totalSteps">
        Next
        <i class="fas fa-chevron-right"></i>
        </button>
        }@else{
        <button (click)="submit()" *ngIf="!showSurveySelection">
          Submit
          <i class="fas fa-chevron-right"></i>
        </button>
        }
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-container text-center">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>


<div class="under-maintenance" *ngIf="!surveyList?.length && !isLoading">
  <i class="fa-solid fa-tools icon-bar"></i>
  <div class="name">There are no surveys currently</div>
</div>
